import { userApiService as p } from "@waitroom/common-api";
import { LOGGER_SERVICE_AUTH as c } from "@waitroom/models";
import { getRequestData as A } from "@waitroom/react-query";
import { tryCatchAsync as U, isFunction as N, withLock as I } from "@waitroom/utils";
import { logger as o, callbacks as P } from "./config.es.js";
import { refreshTokenLockName as k } from "./constants.es.js";
import { authService as n } from "./service.es.js";
import { useAuthStore as a, setAuthState as S, setCurrentUser as D, updateAuthState as m, setSubscriptionPlan as R } from "./store.es.js";
const y = (e) => !!e.isAuthenticated && !!e.userId && !e.isGuest;
let h;
const F = (e) => new Promise(async (t) => {
  var f;
  h && clearTimeout(h);
  const { expires: s, refreshToken: r } = e;
  if (!s || !r) return;
  const u = ~~(6e4 + Math.random() * 24e4), i = Math.max(0, s * 1e3 - Date.now() - u);
  (f = o) == null || f.logService(c, 3, "Refresh auth token setup timeout", i), h = setTimeout(
    I(k, async () => {
      var b;
      (b = o) == null || b.logService(c, 3, "Refresh auth token timeout");
      const d = await n.refresh(e.refreshToken) || await n.logout();
      return d && (m(d), d.isAuthenticated ? v() : l()), t(d);
    }),
    i
  );
}), g = async (e) => {
  const t = await F(e);
  return t != null && t.isAuthenticated && g(t), t;
}, L = 6e5;
let T;
const _ = (e) => new Promise(async (t) => {
  T = setTimeout(async () => {
    const s = await p.getSubscriptionPlan(e);
    return t(s);
  }, L);
});
async function w() {
  T && clearTimeout(T);
  const e = a.getState();
  if (!y(e)) return;
  const t = await _(e.userId), s = A(t);
  s && t.success && R(s), w();
}
const v = () => {
  var e, t, s;
  (e = o) == null || e.logService(c, 3, "Authenticated"), (s = (t = P).onAuthenticated) == null || s.call(t, a.getState()), x();
}, l = () => {
  var e, t, s;
  (e = o) == null || e.logService(c, 3, "Unauthenticated"), (s = (t = P).onUnAuthenticated) == null || s.call(t, a.getState());
}, B = async () => {
  var t;
  (t = o) == null || t.logService(c, 1, "initAuth");
  const e = await n.setup();
  return e.refreshToken && g(e), S(e), e.isAuthenticated ? v() : l();
}, x = async () => {
  var r;
  const e = a.getState();
  if (!y(e)) return;
  const t = await U(p.getCurrent)();
  if (t != null && t.code && t.code >= 400 && t.code <= 500) {
    E();
    return;
  }
  const s = (r = A(t)) == null ? void 0 : r.user;
  if (s) {
    const u = {
      id: s.userID,
      firstName: s.userFirstName,
      lastName: s.userLastName,
      ...s
    };
    D(u), w();
    return;
  }
}, J = async (e, t) => {
  var f;
  (f = o) == null || f.logService(c, 1, "setupAuth");
  const {
    accessToken: s,
    refreshToken: r,
    userId: u
  } = a.getState() || {};
  if (s === (e == null ? void 0 : e.accessToken) && r === (e == null ? void 0 : e.refreshToken)) {
    t && t();
    return;
  }
  const i = await n.setup(
    e ? {
      accessToken: e.accessToken,
      refreshToken: e.refreshToken
    } : void 0
  );
  i.refreshToken && g(i), i.isAuthenticated && w(), u === i.userId ? m(i) : S(i), i.isAuthenticated ? v() : l(), m({ status: "initialized" }), t && N(t) && t();
}, E = async (e) => {
  m({ status: "loading" }), h && clearTimeout(h), a.getState().isAuthenticated && await n.logout(e), S(n.getAnonymous()), l();
}, K = async () => {
  const e = a.getState();
  if (!y(e)) return;
  const t = await p.getSubscriptionPlan(e.userId), s = A(t);
  s && t.success && R(s);
}, Q = async () => {
  var t;
  (t = o) == null || t.logService(c, 3, "Refreshing auth");
  const e = a.getState();
  I(k, async () => {
    const r = await n.refresh(e.refreshToken) || await n.logout();
    r && (m(r), r != null && r.isAuthenticated && g(r));
  })();
};
export {
  v as authenticated,
  x as getCurrentUser,
  B as initAuth,
  E as logout,
  Q as refreshAuth,
  K as refreshSubscriptionPlan,
  J as setupAuth,
  l as unAuthenticated
};
